
// eslint-disable-next-line no-unused-vars
import { IRegionFilters } from "@/interfaces/region_filters";
// eslint-disable-next-line no-unused-vars
import GradeFilter from "../model/grade_filter";
// eslint-disable-next-line no-unused-vars
import { defineComponent, watch, ref, PropType, onBeforeMount, inject } from "vue";
// eslint-disable-next-line no-unused-vars
import IConfigurationService from "@/interfaces/configuration_service";

export default defineComponent({
  props: {
    gradeFilter: Object as PropType<GradeFilter>,
    activeFilter: String
  },
  emits: ["filter-clicked"],
  setup(props, { emit }) {
    const configurationService = inject<IConfigurationService>("configurationService");
    const currentlyActiveFilter = ref(props.activeFilter);
    const selectedRegion = configurationService?.getSelectedRegion();
    const gradeFilterToApply = ref(props.gradeFilter);
    const isThisAFeis= ref<string>("false");
    const isThisAClass= ref<string>("false");
    const bunLabel = ref<string>("Bun Grad");
    const tusLabel = ref<string>("Tus Grad");
    const meanLabel = ref<string>("Mean Grad");
    const openLabel = ref<string>("Open");

    if (gradeFilterToApply?.value) {
      watch(gradeFilterToApply, applyInactiveFilter);
    }
    if (currentlyActiveFilter?.value) {
      watch(currentlyActiveFilter, applyInactiveFilter);
    }

    function selectFilter(filterName: string) {
      emit("filter-clicked", filterName);
      currentlyActiveFilter.value = filterName;
    }

    function applyInactiveFilter() {
      return gradeFilterToApply?.value?.grade !== currentlyActiveFilter?.value
        ? "inactive"
        : "active";
    }

    function getFeisStatusAndLabels()
    {
      //const propIsAtFeis = selectedRegion?.map((item: IRegionFilters) => item?.isFeis);
      // const propIsAtClass = selectedRegion?.map((item: IRegionFilters) => item?.isClass);
      // if (propIsAtFeis)
      // {
        isThisAFeis.value = selectedRegion?.map((item: IRegionFilters) => item?.isFeis);
        isThisAClass.value = selectedRegion?.map((item: IRegionFilters) => item?.isClass);
        bunLabel.value = selectedRegion?.map((item: IRegionFilters) => item?.bunTitle);
        tusLabel.value = selectedRegion?.map((item: IRegionFilters) => item?.tusTitle);
        meanLabel.value = selectedRegion?.map((item: IRegionFilters) => item?.meanTitle);
        openLabel.value = selectedRegion?.map((item: IRegionFilters) => item?.openTitle);
        // if (propIsAtFeis?.length > 0)
        // {
        //   isThisAFeis.value = propIsAtFeis[0];
        //   console.log(`BUN LABEL: ${bunLabel.value}`)
        //   console.log(`TUS LABEL: ${tusLabel.value}`)
        //   console.log(`MEAN LABEL: ${meanLabel.value}`)
        //   console.log(`OPEN LABEL: ${openLabel.value}`)
        //   console.log(`isThisAFeis: ${JSON.stringify(propIsAtFeis[0])} truthy: ${propIsAtFeis[0] === "true"} truthy2: ${isThisAFeis.value === 'true'}`)
        // }
        console.log(`IsThisAFeis: ${isThisAFeis.value}`);
      // }
    }

    onBeforeMount(function()
    {
      getFeisStatusAndLabels();
    });

    return {
      // eslint-disable-next-line vue/no-dupe-keys
      gradeFilterToApply,
      applyInactiveFilter,
      selectFilter,
      selectedRegion,
      isThisAFeis,
      bunLabel,
      tusLabel,
      meanLabel,
      openLabel
    };
  },
});
